import PageHeader from '../form/layout/PageHeader.react';
import StatusPage from '../status/StatusPage.react';

class GLSystemStatus extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };


    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        var self = this,
            page = this.props.page,
            user = this.props.user,
            selectedLocation = this.props.selectedLocation;

        if (page !== 'status')
            return null;

        return (
            <div className='settings'>
                <div className='container'>
 
                    <PageHeader title='System Status' />
                    <StatusPage user={this.props.user} selectedLocation={selectedLocation} />
                    
                </div>
            </div>
        );
    }
}

export default GLSystemStatus;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLSystemStatus.react.jsx